import React, { useEffect, useState } from 'react';
import { GrUserSettings, GrClose, GrTrash } from 'react-icons/gr';
import { isAdminRole } from '../../utils/userActionUtils';
import { ConfirmModal } from '../ConfirmModal/ConfirmModal';
import { useQnAConfigContext } from '../QnAConfigModal/contexts/QnAConfigContext';
import { QnAConfigModal } from '../QnAConfigModal/QnAConfigModal';
import { useQnAContext } from './contexts/QnAContext';
import { QnAChatArea } from './QnAChatArea';
import { QnAErrorAlert } from './QnAErrorAlert';
import { QnAInputArea } from './QnAInputArea';
import { QnANotificationAlert } from './QnANotificationAlert';
import styles from './QnAWidget.module.scss';

export function QnAWidgetWindow() {
  const { isExpanded, toggleExpanded, clearChatHistory } = useQnAContext();
  const { openConfigModal } = useQnAConfigContext();
  const [showClearConfirm, setShowClearConfirm] = useState(false);

  const windowWidth = Math.max(window.innerWidth * 0.3, 200);
  const windowHeight = Math.max(window.innerHeight * 0.75, 400);

  // Handle ESC key to close widget only when widget is expanded
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && isExpanded) {
        toggleExpanded();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [toggleExpanded, isExpanded]);

  const handleClearChat = () => {
    setShowClearConfirm(true);
  };

  const handleConfirmClear = () => {
    clearChatHistory();
    setShowClearConfirm(false);
  };

  const handleCancelClear = () => {
    setShowClearConfirm(false);
  };

  return (
    <div
      className={styles.widgetWindow}
      style={{
        width: windowWidth,
        height: windowHeight,
      }}
    >
      <div className={styles.widgetContent}>
        <div className={styles.widgetHeader}>
          <span>QnA Assistant</span>
          <div className={styles.headerButtons}>
            <button
              className={styles.clearButton}
              onClick={handleClearChat}
              title="Clear chat history"
              type="button"
            >
              <GrTrash size={16} />
            </button>
            {isAdminRole() && (
              <button
                className={styles.configButton}
                onClick={openConfigModal}
                title="AI Service Settings"
                type="button"
              >
                <GrUserSettings size={16} />
              </button>
            )}
            <button
              className={styles.closeButton}
              onClick={toggleExpanded}
              title="Close"
              type="button"
            >
              <GrClose size={16} />
            </button>
          </div>
        </div>

        <div className={styles.errorAlert}>
          <QnAErrorAlert />
        </div>

        <div className={styles.notificationOverlay}>
          <QnANotificationAlert />
        </div>

        <QnAChatArea />

        <QnAInputArea />
      </div>

      <QnAConfigModal />

      <ConfirmModal
        show={showClearConfirm}
        title="Clear Chat History"
        confirmButtonTitle="Clear"
        cancelButtonTitle="Cancel"
        isLoading={false}
        onConfirm={handleConfirmClear}
        onCancel={handleCancelClear}
      >
        <p className="text-center">
          This will permanently delete all chat messages.
          <br />
          Are you sure you want to continue?
        </p>
      </ConfirmModal>
    </div>
  );
}
